import {faFacebookF, faWhatsapp, faFacebook} from "@fortawesome/free-brands-svg-icons"

import {whatsappUrlMessage} from '@/utils'

export const MainMenu = [
    {
        name: 'Inicio',
        route: 'inicio',
        hide: false,
    },
    {
        name: 'Nosotros',
        route: 'about',
    },
    {
        name: 'Productos',
        route: 'cartera.index',
    },
    {
        name: 'Novedades',
        route: 'novedades',
    },
]


export const SocialMenu = [
    {
        name: "Whatsapp", href: whatsappUrlMessage('¡Hola!'), external: true,
        color: "#49e176", icon: faWhatsapp
    }, {
        name: "Facebook", href: "https://www.facebook.com/iqsac.com.pe", external: true,
        color: "#3b5998", icon: faFacebookF, lateralIcon: faFacebook
    }
]